import { render, staticRenderFns } from "./PlanItem.vue?vue&type=template&id=64ff862c&scoped=true&"
import script from "./PlanItem.vue?vue&type=script&lang=ts&"
export * from "./PlanItem.vue?vue&type=script&lang=ts&"
import style0 from "./PlanItem.vue?vue&type=style&index=0&id=64ff862c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ff862c",
  null
  
)

export default component.exports